import { render } from "./Detail.vue?vue&type=template&id=4da55e2a&scoped=true&ts=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=4da55e2a&lang=scss&scoped=true"
import "./Detail.vue?vue&type=style&index=1&id=4da55e2a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da55e2a"]])

export default __exports__